import {Row} from "reactstrap";
import React from "react";
import BusyIndicator from "../../../../components/Common/BusyIndicator";

const Loader = () =>{
  return <Row style={{minHeight:'100vh', position: 'relative', backgroundColor:'white'}} className='d-flex justify-content-center align-items-center align-content-center'>
    <div className='d-flex'>
      <BusyIndicator busy={true}/>
    </div>
  </Row>
}

export default Loader
